import { getIsBellyUpMenuAvailable, getIsCurrentMenuBellyUp } from '../../selectors/menus'
import { store } from '../../stores'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../../VNConfigurations/Enums'
import { isFeatureOn } from '../../VNConfigurations/Selectors'

export const getKioskOfflineEnabled = ({ fromAttractLoop }) => {
  const state = store.getState()

  const kioskOffline = isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.KIOSK_OFFLINE)
  const isCurrentMenuBellyUp = getIsCurrentMenuBellyUp(state)
  const isBellyUpMenuAvailable = getIsBellyUpMenuAvailable(state)

  //first check feature flag is off
  if (!kioskOffline) {
    return false
  }

  //when the user is in the attract loop if there's a belly up menu we'll let the user to be routed to next screen
  if (fromAttractLoop) {
    return isBellyUpMenuAvailable
  }

  //for all other places (not the attract loop) we just need to look at the current menu
  return isCurrentMenuBellyUp
}
